import { useQuery } from "@tanstack/react-query";

import type { PersonInput } from "@/api/router/financeiro/schemas";
import { orpc } from "@/client";
import { format } from "@/lib/format";
import { PessoaLabels } from "@/lib/labels";
import { FinanceiroLabels } from "@/lib/labels/financeiro";
import { cn } from "@/lib/utils";

export function FinancePanel({ identity }: { identity: PersonInput }) {
	const finance = useQuery(
		orpc.financeiro.receipts.person.queryOptions({
			input: identity,
			retry: false,
		}),
	);

	if (finance.data === undefined) {
		return null;
	}

	if (finance.data.data.length === 0) {
		return (
			<p data-component="finance-panel-empty" className="text-xs italic text-muted-foreground">
				{PessoaLabels.fichaTabPlaceholder.financeiro}
			</p>
		);
	}

	return (
		<div data-component="finance-panel" className="flex flex-col gap-3">
			<p className="text-sm font-semibold text-foreground">Recebimentos da pessoa</p>

			<div className="divide-y divide-border">
				{finance.data.data.map((receipt) => (
					<div
						key={receipt.id}
						className={cn(
							"flex items-center justify-between gap-3 py-2",
							receipt.state === "cancelled" && "text-muted-foreground line-through",
						)}
					>
						<div className="min-w-0">
							<p className="text-xs font-medium text-foreground">
								{FinanceiroLabels.receipt.method[receipt.method]}
							</p>
							<p className="text-xs text-muted-foreground">
								{format.date(receipt.received_on)}
								{receipt.description !== null && `, ${receipt.description}`}
								{receipt.state !== "confirmed" &&
									`, ${FinanceiroLabels.receipt.state[receipt.state]}`}
							</p>
						</div>
						<span className="font-mono text-xs tabular-nums text-foreground">
							{FinanceiroLabels.money(receipt.amount_cents)}
						</span>
					</div>
				))}
			</div>
		</div>
	);
}
